import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Label, makeStyles, tokens } from "@fluentui/react-components";
import { Add16Filled } from "@fluentui/react-icons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import { checkUserPermission } from "../../../../utils";
import { UserPermissionsList } from "../../../../config";

import ContentLoader from "../../../../components/Loader/ContentLoader";
import ASCButton from "../../../../components/Button";
import { getIncomeCategoryListItems } from "../../../../redux/SystemManager/incomeCategories";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";
const useStyles = makeStyles({
  field: {
    display: "grid",
    gap: tokens.spacingVerticalS,
    marginBottom: "20px",
  },
  wrapper: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "10px 10px 0",
  },
});

function IncomeCategoryHomePage() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { itemId, action } = useParams<{
    itemId: string;
    action?: string;
  }>();
  const { authUser, incomeCategories } = useSelector((state: RootState) => ({
    authUser: state.authUser,
    incomeCategories: state.incomeCategories,
  }));
  const styles = useStyles();
  useEffect(() => {
    dispatch(getIncomeCategoryListItems());
  }, [dispatch]);
  useEffect(() => {
    if (incomeCategories.listItems.length > 0) {
      navigate(
        `/system-manager/customisations/income-category/${
          incomeCategories.listItems[0]?.id
        }/${action || "view"}`
      );
    }
  }, [action, navigate, incomeCategories.listItems]);
  return (
    <div>
      {incomeCategories.loading ? (
        <ContentLoader />
      ) : incomeCategories.listItems.length === 0 ? (
        <div>
          <div className={styles.wrapper}>
            {checkUserPermission(
              authUser,
              UserPermissionsList.ALLOW_UPDATE_MASTER_DATA
            ) && (
              <ASCButton
                shape="rounded"
                appearance="primary"
                className="asc-button-primary"
                icon={<Add16Filled />}
                size="medium"
                onClick={() =>
                  navigate(`/system-manager/customisations/income-category/add`)
                }
                label="Add New"
              />
            )}
          </div>
          <NoDataFound />
        </div>
      ) : null}
    </div>
  );
}

export default IncomeCategoryHomePage;
